export const environment = {
  production: false,
  API_URL: "https://api.brandtarinha.com/v1",
  imageUrl: "https://api.brandtarinha.com/media/",
};
